import { render, staticRenderFns } from "./showuserviews.vue?vue&type=template&id=30d25dc3"
import script from "./showuserviews.vue?vue&type=script&lang=js"
export * from "./showuserviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports